import axios from "axios";
import { se } from "date-fns/locale";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

export async function edit({ id, data }) {
  try {
    const res = await axios.post("/food/view-edit-sample/edit-sample", {
      id: id,
      data: data,
    });
    return res.data;
  } catch (error) {
    console.error("Error: ", error);
  }
}
export async function editExperiment({ id, data }) {
  try {
    const res = await axios.post("/food/view-edit-sample/edit-experiment", {
      id: id,
      data: data,
    });
    return res.data;
  } catch (error) {
    console.error("Error: ", error);
  }
}

export async function commonMatrices(ldate, selectedLocation) {
  const { data } = await axios.post("/food/body-stats/commonMatrices", {
    ldate,
    selectedLocation,
  });
  return data;
}
